var React = require('react');

function CarrotRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 7L6.78566 6.76191L2.52845 2L2 2.47619L6.04287 7L2 11.5238L2.52845 12L6.78566 7.2381L7 7Z","fill":"currentColor","stroke":"currentColor","strokeWidth":"2"}));
}

CarrotRight.defaultProps = {"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none"};

module.exports = CarrotRight;

CarrotRight.default = CarrotRight;
